import { RequiredDocumentTypeEnum } from "@repo/core/enums/proposals";

export type ManualCaptureNavigation = {
  documentType: RequiredDocumentTypeEnum;
  cameraFacing: "front" | "back";
  shouldDismissActionSheet: boolean;
};

const isManualBiometryDocument = (documentType: RequiredDocumentTypeEnum) =>
  documentType === RequiredDocumentTypeEnum.BIOMETRY ||
  documentType === RequiredDocumentTypeEnum.BIOMETRY_FACE;

export const resolveManualCaptureNavigation = (
  selectedDocumentType?: RequiredDocumentTypeEnum,
  currentDocumentType?: RequiredDocumentTypeEnum | null
): ManualCaptureNavigation | null => {
  const documentType = selectedDocumentType ?? currentDocumentType;

  if (!documentType) {
    return null;
  }

  return {
    documentType,
    cameraFacing: isManualBiometryDocument(documentType) ? "front" : "back",
    shouldDismissActionSheet: selectedDocumentType === undefined
  };
};
